<div class="container-fluid organization-container overflow-hidden products-form-container">
	<div class="row" *ngIf="!viewMode">

		<div class="go-back-container">
			<div class="go-back">
				<a routerLink="/global-configuration/product/product-list">
					<i class="fa fa-arrow-left"></i>
					<span>Products List</span>
				</a>
			</div>
			<div class="go-back-container__title">{{ title }}</div>
		</div>

		<div class="buttons">
			<button class="btn btn-sm cv-btn-light" [disabled]="saving"
					routerLink="/global-configuration/product/product-list">
				CANCEL
			</button>
			<button [disabled]="saving || !isFormValid" class="btn btn-sm cv-btn-blue" (click)="onSave()">
				<div *ngIf="saving" class="loading-wrapper">
					<i class="fas fa-spinner"></i>
				</div>
				SAVE
			</button>
		</div>
	</div>
	<div class="row">
		<div class="col info-content basic-info">
			<h4 class="mt-4">BASIC INFO</h4>
			<p class="mb-4 info-test">
				Once you select the Origin (located below) you will be able to enable or
				disable the integrations located in the right panel to add relevant
				information about this order. Fields marked with red are required.
			</p>

			<cv-form-field *ngIf="formIsReady" [options]="{ path: 'origin' }"></cv-form-field>

			<hr class="mb-4 mt-5"/>

			<cv-form-field *ngIf="formIsReady" [options]="{ path: 'title' }"></cv-form-field>
			<cv-form-field *ngIf="formIsReady" [options]="{ path: 'alternativeName' }"></cv-form-field>


			<hr class="mb-4 mt-5"/>
			<cv-form-field *ngIf="formIsReady" [options]="{ path: 'channel' }"></cv-form-field>
			<cv-form-field *ngIf="formIsReady" [options]="{ path: 'productType' }"></cv-form-field>
			<cv-form-field *ngIf="formIsReady" [options]="{ path: 'valuationType' }"></cv-form-field>

			<cv-form-field *ngIf="formIsReady" [options]="{ path: 'active' }"></cv-form-field>
			<cv-form-field *ngIf="formIsReady" [options]="{ path: 'isOrganizationLevel' }"></cv-form-field>
			<cv-form-field *ngIf="formIsReady" [options]="{ path: 'isUAD36Product' }"></cv-form-field>

			<cv-form-field *ngIf="formIsReady" [options]="{ path: 'description' }"></cv-form-field>

		</div>
		<div class="col info-content integration-info" [ngClass]="{'readOnly': viewMode}">
			<div class="product-check-container integrations-container border-b" *ngIf="canSetIntegration">
				<h5 class="tracking-system-title">INTEGRATIONS:</h5>
				<cv-form-field *ngIf="formIsReady" [options]="{ path: 'nexsys.enabled' }"></cv-form-field>
				<cv-form-field *ngIf="formIsReady" [options]="{ path: 'valutrust.enabled' }"></cv-form-field>
				<cv-form-field *ngIf="formIsReady" [options]="{ path: 'xpanse.enabled' }"></cv-form-field>
				<cv-form-field *ngIf="formIsReady" [options]="{ path: 'integration.enabled' }"></cv-form-field>
			</div>
			<div class="product-check-container border-b" *ngIf="originSelected">
				<h5 class="tracking-system-title">TRACKING SYSTEMS:</h5>
				<cv-form-field *ngIf="formIsReady" [options]="{ path: 'appScope.enabled' }"></cv-form-field>
				<cv-form-field *ngIf="formIsReady" [options]="{ path: 'acuity.enabled' }"></cv-form-field>
			</div>
			<div class="integration-form form-type-{{ originSelected.toLowerCase() }}" [ngClass]="{
							'remove-padding': canSetIntegration
						}" *ngIf="originSelected; else emptySelection">
				<fieldset *ngIf="integrationEnabled">
					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'integration.integrationId' }"></cv-form-field>

					<div>

						<h6 *ngIf="(integrationSelected !== 'integration' && integrationSelected) || genericIntegrationSelected">{{
								integrationSelected !== 'integration' ? integrationSelected : genericIntegrationSelected
							}} Integration</h6>

						<p class="info-test"
						   *ngIf="(integrationSelected !== 'integration' && integrationSelected) || genericIntegrationSelected">
							{{
								integrationSelected !== 'integration' ? integrationSelected : genericIntegrationSelected
							}} Integration (Select
							the product that the incoming order need to match)
						</p>

						<ng-container *ngFor="let integration of integrations">
							<cv-form-field *ngIf="formIsReady && integration === integrationSelected"
										   [options]="{ path: integration + '.isDefaultProduct' }"></cv-form-field>
							<cv-form-field *ngIf="formIsReady && integration === integrationSelected"
										   [options]="{ path: integration + '.productId' }"></cv-form-field>

							<div *ngIf="integration === integrationSelected"
								 class="inline-section integration-container">
								<cv-form-field *ngIf="formIsReady && integration === integrationSelected"
											   [options]="{ path: integration + '.isFhaProduct' }"></cv-form-field>
								<cv-form-field *ngIf="formIsReady && integration === integrationSelected"
											   [options]="{ path: integration + '.isOrderIncomeStatement' }"></cv-form-field>
								<cv-form-field *ngIf="formIsReady && integration === integrationSelected"
											   [options]="{ path: integration + '.isOrderRentSchedule' }"></cv-form-field>
							</div>

							<cv-form-field *ngIf="formIsReady && integration === integrationSelected"
										   [options]="{ path: integration + '.defaultFhaNumber' }"></cv-form-field>
						</ng-container>

						<cv-form-field *ngIf="formIsReady" [options]="{ path: 'nexsys.orderAttribute' }"></cv-form-field>

					</div>
				</fieldset>


				<fieldset class="border-b" *ngIf="appScopeEnabled">
					<h6>AppScope Tracker</h6>
					<p class="mb-4 info-test">{{ enableAppScopeMsg }}</p>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'appScope.jobId' }"></cv-form-field>
					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'appScope.invoice' }"></cv-form-field>

					<p class="mb-3"></p>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'appScope.creationTrigger' }"></cv-form-field>

					<p class="mb-3"></p>
					<cv-form-field *ngIf="formIsReady"
								   [options]="{ path: 'appScope.creationStatusTrigger' }"></cv-form-field>
					<p class="mb-3"></p>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'appScope.productAssetsId' }"></cv-form-field>

					<cv-form-field *ngIf="formIsReady"
								   [options]="{ path: 'appScope.disableCommunications' }"></cv-form-field>
					<cv-form-field *ngIf="formIsReady"
								   [options]="{ path: 'appScope.enqueueCommunications' }"></cv-form-field>
					<cv-form-field *ngIf="formIsReady"
								   [options]="{ path: 'appScope.borrowerEmailToComments' }"></cv-form-field>
					<cv-form-field *ngIf="formIsReady"
								   [options]="{ path: 'appScope.associatedOrderProductType' }"></cv-form-field>
				</fieldset>


				<fieldset class="border-b">
					<h6>Acuity Tracker</h6>
					<p class="mb-4 info-test">{{ enableAcuityMsg }}</p>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'acuity.instance'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'acuity.productId'
											}">
					</cv-form-field>

					<p class="mb-3"></p>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'acuity.productAssetsId'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'acuity.disableCommunications'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'acuity.bpoProduct'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'acuity.bpoLinkTrigger'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'acuity.is3dProduct'
											}">
					</cv-form-field>
					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'inspection.enabled'
											}">
					</cv-form-field>

					<div class="ms-5">
						<cv-form-field *ngIf="formIsReady" [options]="{ path: 'inspection.injectImagesIntoForm'
											}">
						</cv-form-field>
					</div>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'enableHandheld'
											}">
					</cv-form-field>


					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'acuity.invoice'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'inspection.keepInspection'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'inspection.schema'
											}">
					</cv-form-field>

					<p class="mb-3"></p>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'inspection.gsePreference'
											}">
					</cv-form-field>

					<div class="row">
						<div class="col-6">
							<cv-form-field *ngIf="formIsReady" [options]="{ path: 'inspection.gseFungible'
											}">
							</cv-form-field>

						</div>

						<div class="col-6">
							<cv-form-field *ngIf="formIsReady" [options]="{ path: 'inspection.useUPD'
											}">
							</cv-form-field>
						</div>
					</div>

					<div class="row">
						<div class="col-6">
							<cv-form-field *ngIf="formIsReady" [options]="{ path: 'inspection.disableFREDDIESubmition'
											}">
							</cv-form-field>

						</div>

						<div class="col-6">
							<cv-form-field *ngIf="formIsReady" [options]="{ path: 'inspection.disableFNMASubmition'
											}">
							</cv-form-field>
						</div>
					</div>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'inspection.softwareCollector'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'licensingServiceSetting.enabled'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'licensingServiceSetting.acuityCreationSetting.acuityProductId'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady && licensingServiceEnabled" [options]="{
			  					path: 'licensingServiceSetting.subProductConfiguration.products',
			  					index: 0,
			  					childKey: 'id'
							}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady && licensingServiceEnabled" [options]="{
			  					path: 'licensingServiceSetting.subProductConfiguration.products',
			  					index: 0,
			  					childKey: 'creationTrigger'
							}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady && licensingServiceEnabled" [options]="{
			  					path: 'licensingServiceSetting.subProductConfiguration.products',
			  					index: 1,
			  					childKey: 'id'
							}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady && licensingServiceEnabled" [options]="{
			  					path: 'licensingServiceSetting.subProductConfiguration.products',
			  					index: 1,
			  					childKey: 'creationTrigger'
							}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'insideMaps.enabled'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'insideMaps.sendListingLink'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'insideMaps.sendPropertyReportPageLink'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'insideMaps.insideMapsId'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'insideMaps.insideMapsFee',
												onlyDigits: true,
												min: 0
											}">
					</cv-form-field>

					<div class="mt-3" *ngIf="canSetSideCar">
						<h6>SubProduct Configuration</h6>
						<p>SIDECAR 1</p>
						<cv-form-field *ngIf="formIsReady && canSetSideCar" [options]="{
			  					path: 'subProductConfiguration.products',
			  					index: 0,
			  					childKey: 'id'
							}">
						</cv-form-field>

						<cv-form-field *ngIf="formIsReady && canSetSideCar" [options]="{
			  					path: 'subProductConfiguration.products',
			  					index: 0,
			  					childKey: 'subProductFee'
							}">
						</cv-form-field>

						<cv-form-field *ngIf="formIsReady && canSetSideCar" [options]="{
			  					path: 'subProductConfiguration.products',
			  					index: 0,
			  					childKey: 'creationTrigger'
							}">
						</cv-form-field>

						<cv-form-field *ngIf="formIsReady && canSetSideCar" [options]="{
			  					path: 'subProductConfiguration.products',
			  					index: 0,
			  					childKey: 'creationStatusTrigger'
							}">
						</cv-form-field>

						<cv-form-field *ngIf="formIsReady && canSetSideCar" [options]="{
			  					path: 'subProductConfiguration.products',
			  					index: 0,
			  					childKey: 'hybridMode'
							}">
						</cv-form-field>

						<p class="mb-3"></p>

						<p>SIDECAR 2</p>
						<cv-form-field *ngIf="formIsReady && canSetSideCar" [options]="{
			  					path: 'subProductConfiguration.products',
			  					index: 1,
			  					childKey: 'id'
							}">
						</cv-form-field>

						<cv-form-field *ngIf="formIsReady && canSetSideCar" [options]="{
			  					path: 'subProductConfiguration.products',
			  					index: 1,
			  					childKey: 'hybridMode'
							}">
						</cv-form-field>
					</div>

					<hr class="mb-3">


					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'appScope.enableAcuityFileSincronization'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'acuity.autoCompleteScopeOrderOption.autoComplete'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'acuity.autoCompleteScopeOrderOption.autoCompleteMilestoneTrigger'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'acuity.autoCompleteScopeOrderOption.uploadDocuments'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'acuity.autoCompleteScopeOrderOption.uploadDocumentsMilestone'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'acuity.autoCompleteScopeOrderOption.documents'
											}">
					</cv-form-field>

					<cv-form-field *ngIf="formIsReady" [options]="{ path: 'acuity.notifyAppscopeAcuityOrderEscalated'
											}">
					</cv-form-field>
				</fieldset>
			</div>
			<ng-template #emptySelection>
				<div class="empty-selection__content">
					<label class="empty-selection__icon"><i class="fas fa-file"></i></label>
					<label class="empty-selection__lbl">No Origin Selected</label>
					<label class="empty-selection-instruction__lbl">
						Select an Origin from the list to see integration related to it
					</label>
				</div>
			</ng-template>
		</div>
	</div>
</div>
